import React, { useCallback } from 'react'

import { useI18n } from '@affiliate-cabinet/i18n'
import { FiltersPanel, useForm } from '@affstore-ds/uikit'

import { FilterButtons } from '../../../../../../../features/FilterButtons'
import { LocalesMultiSelect } from '../../../../../../../features/LocalesMultiSelect'
import { PromoBannerFileFormatsMultiSelect } from '../../../../../../../features/PromoBannerFileFormatsMultiSelect'
import { PromoBannerSizesMultiSelect } from '../../../../../../../features/PromoBannerSizesMultiSelect'
import { filtersTranslationKeys } from '../../../../../../../shared/translations/filters.translationKeys'
import { PROMO_BANNERS_ID_DEFAULT_FILTERS } from '../../constants/filters'
import { PromoBannersIdFiltersType, PromoLandingsFiltersFormInterface } from './PromoLandingsFiltersForm.types'

export const PromoBannersIdFiltersForm = ({ filters, imageSizes, loading, onChange }: PromoLandingsFiltersFormInterface) => {
  const { i18n } = useI18n()

  const form = useForm<PromoBannersIdFiltersType>({
    initialValues: {
      fileFormats: filters.fileFormats || PROMO_BANNERS_ID_DEFAULT_FILTERS.fileFormats,
      imageSizes: filters.imageSizes || PROMO_BANNERS_ID_DEFAULT_FILTERS.imageSizes,
      locales: filters.locales || PROMO_BANNERS_ID_DEFAULT_FILTERS.locales,
    },
  })

  const handleChange = useCallback(
    (values: PromoBannersIdFiltersType) => {
      onChange({ ...values })
    },
    [onChange],
  )

  return (
    <FiltersPanel
      collapseHideText={i18n.t(filtersTranslationKeys.filtersCollapseHideText)}
      data-testid="promo-banner-item-filters"
      title={i18n.t(filtersTranslationKeys.filtersTitle)}
      filtersButtonsSlot={
        <FilterButtons
          filters={filters}
          form={form}
          loading={loading}
          omittedToCheckFormValues={['first', 'skip']}
          resetFormValues={PROMO_BANNERS_ID_DEFAULT_FILTERS}
          variant="responsive"
        />
      }
      filtersNotCollapsibleSlot={
        <>
          <LocalesMultiSelect name="locales" disabled={loading} {...form.getInputProps('locales')} />
          <PromoBannerSizesMultiSelect name="imageSizes" disabled={loading} imageSizes={imageSizes} {...form.getInputProps('imageSizes')} />
          <PromoBannerFileFormatsMultiSelect name="fileFormats" disabled={loading} {...form.getInputProps('fileFormats')} />
        </>
      }
      collapseShowText={i18n.t(filtersTranslationKeys.filtersCollapseShowText)}
      filtersPanelSessionStorageKey="promo-banner-item-filters-panel"
      loading={loading}
      onSubmit={form.onSubmit(handleChange)}
      variant="responsive"
    />
  )
}
